module.exports = __webpack_public_path__ + "static/media/credit_card.5730805d.png";